<button (click)=openDialog() class="button action">Upload File</button>